import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';

import { withStyles } from '../tools/withStyles';
import { Main } from '../components/Main';
import { Secuence } from '../components/Secuence';
import { Text } from '../components/Text';
import { Fader } from '../components/Fader';
import { Link } from '../components/Link';

const pillars = [
  { n: '01', title: 'Eventos que inspiran' },
  { n: '02', title: 'Comunidades que conectan' },
  { n: '03', title: 'Historias que viven' },
  { n: '04', title: 'Experiencias que trascienden' }
];

const allies = [
  { src: '/images/omticket.png', alt: 'Omticket', href: 'https://www.omticket.com/', note: 'Venta oficial' },
  { src: '/images/aliado-kamen-music.png', alt: 'Kamen Music', href: 'https://portalpopculture.com/', note: 'Con el apoyo de' },
  { src: '/images/aliado-centro-japon.png', alt: 'Centro Japón Occidente', href: 'https://portalpopculture.com/', note: 'Con el apoyo de' },
  { src: '/images/aliado-ia.png', alt: 'IA.', href: 'https://portalpopculture.com/', note: 'Con el apoyo de' }
];

const styles = theme => ({
  root: {},
  lead: {
    maxWidth: 680
  },
  logo: {
    display: 'block',
    width: 180,
    margin: [8, 'auto', 16]
  },
  pillars: {
    margin: [16, 0],
    padding: 0,
    listStyle: 'none'
  },
  pillar: {
    marginBottom: 8,
    fontFamily: theme.typography.primary
  },
  num: {
    marginRight: 12,
    color: theme.color.secondary.main
  },
  allies: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    margin: [12, -8, 0]
  },
  ally: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 8,
    width: 150
  },
  mark: {
    display: 'block',
    width: '100%',
    height: 72,
    objectFit: 'contain',
    objectPosition: 'center'
  },
  note: {
    margin: [6, 0, 0],
    fontSize: 12,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.color.text.main
  }
});

class Productora extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <Secuence stagger>
          <h1><Text>El portal conecta dos mundos</Text></h1>
          <Fader>
            <img
              className={classes.logo}
              src={withPrefix('/images/logo-portal.svg')}
              alt='Portal Pop Culture'
            />
          </Fader>
          <p className={classes.lead}>
            <Text>La unión entre la ficción y la realidad, entre artistas y fans, entre culturas y comunidades. Un espacio donde las historias que amamos se convierten en experiencias reales.</Text>
          </p>
          <Fader>
            <ul className={classes.pillars}>
              {pillars.map(item => (
                <li key={item.n} className={classes.pillar}>
                  <span className={classes.num}>{item.n}</span>
                  {item.title}
                </li>
              ))}
            </ul>
          </Fader>
          <h2><Text>Aliados</Text></h2>
          <Fader>
            <div className={classes.allies}>
              {allies.map(ally => (
                <Link key={ally.alt} className={classes.ally} href={ally.href} target={ally.alt}>
                  <img className={classes.mark} src={withPrefix(ally.src)} alt={ally.alt} />
                  <span className={classes.note}>{ally.note}</span>
                </Link>
              ))}
            </div>
          </Fader>
          <p>
            <Fader>
              <Link href='https://portalpopculture.com/' target='portal'>portalpopculture.com</Link>
              {' · '}
              <Link href='mailto:contacto@portalpopculture.com' target='correo'>contacto@portalpopculture.com</Link>
              {' · '}
              <Link href='https://wa.me/50672384375' target='whatsapp'>+506 7238 4375</Link>
            </Fader>
          </p>
        </Secuence>
      </Main>
    );
  }
}

export default withStyles(styles)(Productora);
